
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/balicky-provereni",
      function () {
        return require("private-next-pages/balicky-provereni.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/balicky-provereni"])
      });
    }
  